import { CoordinatorService } from './coordinator.service';
import { UploadFile } from './upload-file';

export class Upload$ {
    private _ufMap = new Map<string, UploadFile[]>();
    private _explicitUploadSet = new Set<string>();

    private _messageWidget: any;

    constructor(private coords: CoordinatorService) {}

    localProjectCloudUpload(projectId: string) {
        this.coords.manifest$.post('upload-all', {
            projectId: projectId,
        });
    }

    async uploadAllResponse(resp: any) {
        let totalSize = 0;
        const uploadLs: Promise<any>[] = [];
        const trackPromiseLs: any[] = [];
        const storageParamsLs: any[] = [];
        // const tm = setInterval(() => {
        //     let doneSize = 0;
        //     const resultLs = storageParamsLs
        //         .filter((_, index) => trackPromiseLs.map((x) => x.isSettled())[index])
        //         .map((x) => (doneSize += x.size));
        //     this.coords.project$.refreshMessageWidget(
        //         'info',
        //         `Uploaded ${this.coords.utils$.bytesToHumanReadable(doneSize)} 
        //             of ${this.coords.utils$.bytesToHumanReadable(totalSize)}`,
        //     );
        // }, 1000);
        try {
            const projectId = resp.projectId;

            const fs = this.coords.firebase$.firestore;

            const title = resp.title;

            for (const p of resp.uploadLs) {
                const prefix = `userdata/${this.coords.user$.currentId}/projects/${projectId}`;
                const remotePath = `${prefix}/${p.file.name}`;
                const hash = p.hash;
                const size = p.file.size;
                totalSize += size;
                const prB = this.coords.firebase$.storage.uploadFile(remotePath, p.file);
                uploadLs.push(prB);
                trackPromiseLs.push(this.coords.utils$.trackPromise(prB));
                storageParamsLs.push({ remotePath, projectId, hash, size });
            }

            const isStoredLs = await Promise.all(uploadLs);
            // const userId = this.coords.user$.currentId;
            const storageLs: any[] = [];
            for (let i = 0; i < isStoredLs.length; i++) {
                const p = storageParamsLs[i];
                if (!isStoredLs[i]) {
                    console.log('ERROR STORAGE', p);
                    continue;
                }
                storageLs.push({
                    remotePath: p.remotePath,
                    hash: p.hash,
                    size: p.size,
                    _instId: this.coords.instanceId,
                });

                // const resp2 = await fs.addDocument(
                //     'storage',
                //     p.remotePath,
                //     fs.addTimestampField({
                //         userId,
                //         projectId,
                //         hash: p.hash,
                //         remotePath: p.remotePath,
                //         size: p.size,
                //         _instId: this.coords.instanceId,
                //     }),
                // );
                // if (!resp2) {
                //     throw new Error(`Upload FIRESTORE failed ${p.remotePath}`);
                // }
            }


            const finalResp = await this.coords.firebase$.callFunction('finalizeCloudProject', {
                projectId,
                data: { title },
                storageLs,
            });

            console.log('FINALIZE IN CLOUD RESPONSE', finalResp);

            // const id = `${userId}|${projectId}`;

            // const teamsData = {
            //     userId,
            //     projectId,
            //     hostId: userId,
            //     role: 'owner',
            //     isPending: false,
            // };
            // const resp3 = await fs.addDocument(
            //     'teams',
            //     id,
            //     fs.addTimestampField(teamsData, 'createdAt'),
            // );
            // if (!resp3) {
            //     throw new Error(`CREATE PROJECT MEMBER failed ${id}`);
            // }

            // const projectData = { projectId, data: { title } };

            // await fs.addDocument(
            //     'projects',
            //     projectId,
            //     fs.addTimestampField(projectData, 'createdAt'),
            // );

            const pil = this.coords.project$.getProjectInList(projectId)!;
            if (!pil) location.reload();
            pil.lastOpen = this.coords.utils$.zonedDateTimeNow;
            pil.select();
        } catch (e) {
            alert('UPLOAD ERROR');
            console.log('UPLOAD ERROR', e);
        } finally {
            // clearInterval(tm);
        }
    }

    beforeUnload() {
        console.log('BEFORE UNLOAD INITIALIZED');
        this.activeLs.forEach((x) => x.beforeUnload());
    }

    get isUploadInProgress() {
        for (const ufLs of this._ufMap.values()) {
            for (const uf of ufLs) {
                if (uf.inProgress) return true;
            }
        }
        return false;
    }

    get activeLs() {
        const ls: UploadFile[] = [];
        for (const ufLs of this._ufMap.values()) {
            for (const uf of ufLs) {
                if (uf.inProgress) ls.push(uf);
            }
        }
        return ls;
    }

    manifestResponse(params: any) {
        const uf = new UploadFile(this.coords, params);
        let ls = this._ufMap.get(uf.uploadId);
        if (!ls) {
            ls = [];
            this._ufMap.set(uf.uploadId, ls);
        }
        ls.push(uf);
        uf.start();
    }

    async removeUploadFile(uf: UploadFile) {
        const ls = this._ufMap.get(uf.uploadId)!;
        const i = ls.indexOf(uf);
        if (i === ls.length - 1) {
            this._ufMap.delete(uf.uploadId);
            if (this._explicitUploadSet.size) {
                this._explicitUploadSet.delete(uf.uploadId);
                if (!this._explicitUploadSet.size) {
                    this.coords.display$.closeDialog();
                }
            }
        } else if (i !== -1) {
            this._ufMap.set(uf.uploadId, ls.slice(i + 1));
            ls.slice(0, i).forEach((x) => x.terminate());
        }
    }

    setExplicitUpload(data: string[]) {
        const s = new Set<string>(this._ufMap.keys());
        this._explicitUploadSet = new Set(data.filter((x) => s.has(x)));
    }

    initMessageWidget(messageWidget: any) {
        this._messageWidget = messageWidget;
        let txt = this.coords.text('uploadingLocalDataToCloud');

        this.refreshMessageWidget('info', txt);
    }

    refreshMessageWidget(type: string, message: string) {
        this._messageWidget?.refresh(type, message);
    }

    destroyMessageWidget() {
        this._messageWidget = undefined;
        this.coords.display$.markForCheck();
    }

    isLatestUploadFile(uf: UploadFile) {
        try {
            const ls = this._ufMap.get(uf.uploadId)!;
            return ls[ls.length - 1] === uf;
        } catch (e) {
            return false;
        }
    }
}
